import { CALL_API } from 'redux-api-middleware'
import { get } from 'utils/network'

export const fetchSubmissions = () => {
  const request = get('/grades/submissions')
  request.types = ['_REQ', '_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}



// WEBPACK FOOTER //
// ./src/containers/GradesSubmitted/actions.js